import type { MediaKitPack } from '../../lib/api/operatorConsole';
import { ArchiveButton } from './ArchiveButton';
import { PackArt } from './PackArt';
import { PackArtButton } from './PackArtButton';
import { formatUsd, topCardsLabel } from './mediaKitFormat';

interface Props {
  pack: MediaKitPack;
  cardsCount: number;
}

export function PackHeader({ pack, cardsCount }: Props) {
  return (
    <div className="flex flex-wrap items-start gap-5">
      <PackArt
        src={pack.pack_art?.preview_url ?? null}
        alt={`${pack.title} pack art`}
        className="aspect-[3/4] w-32 shrink-0 rounded-lg border border-[var(--co-border)]"
      />
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-2xl font-bold">{pack.title}</h1>
          <span className="font-mono text-[11px] text-[var(--co-muted)]">#{pack.id}</span>
        </div>
        <p className="text-[12px] text-[var(--co-muted)]">
          {`${formatUsd(pack.price)} · ${topCardsLabel(cardsCount)}`}
        </p>
        <div className="flex flex-wrap items-start gap-2 pt-3">
          {pack.pack_art && <PackArtButton packId={pack.id} asset={pack.pack_art} />}
          <ArchiveButton packId={pack.id} disabled={!pack.pack_art && cardsCount === 0} />
        </div>
      </div>
    </div>
  );
}
